import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M4.813 9.082a2.937 2.937 0 1 1 0 5.875 2.937 2.937 0 0 1 0-5.875zm14.375 0a2.937 2.937 0 1 1 0 5.875 2.937 2.937 0 0 1 0-5.875zm-7.188 0a2.937 2.937 0 1 1 0 5.875 2.937 2.937 0 0 1 0-5.875zm-7.188 1.5a1.437 1.437 0 1 0 0 2.875 1.437 1.437 0 0 0 0-2.875zm14.375 0a1.437 1.437 0 1 0 0 2.875 1.437 1.437 0 0 0 0-2.875zm-7.187 0a1.437 1.437 0 1 0 0 2.875 1.437 1.437 0 0 0 0-2.875z' />
  </svg>
);
